
      <!--  ERROR OVERLAY  -->

      <div class="error-overlay"></div>

      <!-- END ERROR OVERLAY  -->

      <!--  ERROR FRAME  -->

      <div class="error-frame">

          <!--  ERROR HEADER  -->

          <div class="error-frame-header">
              <h2>Something went wrong</h2>
          </div>

          <!--  END ERROR HEADER  -->

          <!--  ERROR BODY  -->

          <div #errorBody class="error-frame-body has-footer written-content" [class.is-scrolling]="isBodyScrolling()">

              <!--  MESSAGES  -->

              <p><strong>We're sorry, there was a problem with our service.</strong></p>
              <p>We have automatically sent an error report so that we can investigate. Apologies for any inconvenience.</p>

              <!--  END MESSAGES  -->

          </div>

          <!--  END ERROR BODY  -->

          <!--  ERROR FOOTER  -->

          <div class="error-frame-footer">

              <!--  RELOAD BUTTON  -->

              <a class="button primary-button" (click)="onReload()">Reload Page</a>

              <!--  END RELOAD BUTTON  -->

          </div>

          <!--  END ERROR FOOTER  -->
      </div>

      <!--  END ERROR FRAME  -->
    